// src/mixins/toastMixin.js
export const toastMixin = {
  methods: {
    showSuccessToast(message) {
      this.$toast.success(message, {
        position: "top-right",
        max: 10
      });
    },
    showErrorToast(message) {
      this.$toast.error(message, {
        position: "top-right",
        max: 10
      });
    },
    generateCode(length, chars) {
      let mask = '';
      if (chars.includes('a')) mask += 'abcdefghijklmnopqrstuvwxyz';
      if (chars.includes('A')) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      if (chars.includes('#')) mask += '0123456789';
      if (chars.includes('!')) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';
      let result = '';
      for (let i = length; i > 0; --i) {
        result += mask[Math.floor(Math.random() * mask.length)];
      }
      return result;
    },
    showSessionExpiredAlert() {
      this.$swal
        .fire({
          html: "<span style='font-size:14px'>Tu sesión se ha expirado, vuelva a iniciar sesión.. </span>",
          position: "center",
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          timer: 4000,
          didOpen: () => {
            this.$swal.showLoading();
          },
        })
        .then(
          () => {
            // Este bloque se ejecuta después de que se cierre automáticamente la alerta
            console.log("closed by timer!!!!");

            localStorage.clear();
            location.reload(true);
          },
          (dismiss) => {
            if (dismiss === "timer") {
              // Este bloque se ejecuta si la alerta se cierra automáticamente por el temporizador
              console.log("closed by timer!!!!");
              this.$swal.fire({
                title: "Finished!",
                icon: "success",
                showConfirmButton: false,
              });
            }
          }
        );
    },
    showOk(title) {
      this.$swal.fire({
        title: title,
        icon: "success"
      });
    },
    showError(title) {
      this.$swal.fire({
        icon: "error",
        title: "Oops...",
        text: title
      });
    },
    showErrorMejor(title) {
      this.$swal.fire({
        title: "Ocurrió algo!",
        html: `<p class="mt-0" style="color: #eb1265; font-weight: bold; font-size: 14px;">${title}</p>`,
        icon: "warning",
        width: "400px",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        buttonsStyling: false,
      });
    },
    showLoading() {
      this.$swal({
        html:
          '<div class="row"><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div><div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"><div class="loader"> </div></div><div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><p style="margin:0px; font-size:16px; text-align:center; font-weight:bold">Consultando, espere...</p></div><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div></div>',
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        position: 'center',
      });
    },
    showLoading2(datos) {
      this.$swal({
        html:
          `<div class="row"><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div><div class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"><div class="loader"> </div></div><div class="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-7"><p style="margin:0px; font-size:16px; text-align:center; font-weight:bold">${datos}</p></div><div class="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2"></div></div>`,
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        position: 'center',
      });
    },
    hideLoading() {
      this.$swal.close();
    },

    calcularEdad(fechaNacimiento) {
      // Convertir la fecha en formato "YYYY-MM-DD" a un objeto Date asegurando el huso horario local
      let [año, mes, dia] = fechaNacimiento.split("-").map(Number);
      let nacimiento = new Date(año, mes - 1, dia); // mes - 1 porque en JavaScript los meses van de 0 a 11
      let hoy = new Date();

      let años = hoy.getFullYear() - nacimiento.getFullYear();
      let meses = hoy.getMonth() - nacimiento.getMonth();
      let dias = hoy.getDate() - nacimiento.getDate();

      // Ajustar si los meses son negativos
      if (meses < 0 || (meses === 0 && dias < 0)) {
        años--;
        meses += 12;
      }

      // Ajustar si los días son negativos
      if (dias < 0) {
        let mesPrevio = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
        dias += mesPrevio.getDate();
        meses--;

        // Verificar si meses se volvió negativo después del ajuste
        if (meses < 0) {
          meses += 12;
          años--;
        }
      }

      return `${años} años ${meses} meses ${dias} días`;
    },

    formatearFecha(fecha) {
      const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

      const date = new Date(fecha);
      const diaSemana = diasSemana[date.getDay()];
      const dia = date.getDate().toString().padStart(2, '0');
      const mes = meses[date.getMonth()];
      const año = date.getFullYear();

      return `${diaSemana}, ${dia} de ${mes} de ${año}`;
    },
  }
}
